import { useParams } from "react-router-dom";
import Error from "../../../Components/Error";
import Loading from "../../../Components/Loading";
import { useGetPostBlogQuery } from "../../../Redux/Apis/blogApi";
import parse from 'html-react-parser';
import { fa_date, fa_number } from "../../../utils/PersianNum";

function Post() {
    let { id } = useParams();

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetPostBlogQuery(id)


    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess) {
        return ( 
            <div class="container mt-5">
            <div className="row">
                <div className="col-lg-8">
                    <article>
                        <header className="mb-2">
                            <h1 className="fw-bolder mb-1">{data.title}</h1>
                            <div className="text-muted fst-italic mb-2">پست شده در تاریخ {fa_date(data.create_date)}</div>
                            <p className="badge bg-secondary text-decoration-none link-light">{data.BlogCategory.name}</p>
                        </header>
                        <figure className="mb-4"><img className="img-fluid rounded" src={data.image} alt="main" /></figure>
                        <section className="mb-5">
                            {parse(data.body)}
                        </section>
                    </article>
                    
                </div>
                <div className="col-lg-4">
                    <div className="card mb-4">
                        <div className="card-header">تگ ها</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-sm-12">
                                    <ul className="list-unstyled mb-0">
                                        {
                                            data.tags && data.tags.split(',').map(value =>
                                                <li>{value}</li>
                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card mb-4">
                        <div className="card-header">آمار پست</div>
                        <div className="card-body">
                            <p>تعداد بازدید: {fa_number(data.views)}</p>
                            <p>تاریخ ایجاد: {fa_date(data.create_date)}</p>
                            <p>آخرین ویرایش: {fa_date(data.update_date)}</p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        );
    }
}

export default Post;